import React from 'react';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
var Navigation = function Navigation(_ref) {
  var navigationItems = _ref.navigationItems;
  return /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs nav-stacked flex-column"
  }, navigationItems.map(function (navItem) {
    return /*#__PURE__*/React.createElement("li", {
      className: "nav-item",
      key: navItem.url
    }, /*#__PURE__*/React.createElement(Link, {
      className: "nav-link ".concat(navItem.selected ? 'active' : ''),
      to: navItem.url
    }, /*#__PURE__*/React.createElement(T, {
      source: navItem.name
    })));
  }));
};
export default Navigation;